<template>
<div class="row justify-content-center col-12 pr-0" v-if="documentsList.length > 0">
    <div class="col-12 d-flex align-items-center mb-3">
        <h4 class="medium ndarkfour">Documentos cadastrais</h4>
    </div>
    <div class="col-12 mt-3 pr-0">
        <div class="list-documents bdc-nmidfour mb-3" v-for="(document, index) in documentsList" :key="index">
            <div class="col-12 d-flex flex-wrap justify-content-between px-0">
                <div class="col-8 d-flex align-items-center">
                    <div>
                        <FileBorder color="#A1A8B8" class="mr-2" />
                    </div>
                    <div>
                        <p class="c-ndarkfour mt-1">{{ document.originalFileName }} </p>
                    </div>
                </div>
                <div class="col-3 justify-content-end d-flex align-items-center">
                    <a :href="`${urlClient}/${document.path}`" target="_blank">
                        <Button size="small" type="outline" color="grey">
                            <Download /> Baixar
                        </Button>
                    </a>
                </div>

            </div>
        </div>
    </div>
</div>
</template>
<script>
import FileBorder from '@/components/icons/FileBorder'
import Download from '@/components/icons/Download'

export default({
    data() {
        return {
            activeTab: '0',
            urlClient: process.env.VUE_APP_ROOT_API,
        }
    },
    props: {
        documentsList: {
            required: true,
            type: Array,
            default: () => ([])
        },
    },
    components: {
        FileBorder,
        Download,
    },
})
</script>
<style lang="scss" scoped>
.list-documents{
    padding: 25px;
    border: 1px solid;
    border-radius: 6px;
}
</style>
